import { graphql, useStaticQuery } from 'gatsby'

export const useSiteMetadata = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          twitterUsername
          title
          siteUrl
          hostName
          pathPrefix
          image
          description
        }
      }
    }
  `)
  return data?.site?.siteMetadata
}
